import type { DisplayAdvertiserPublisherParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";
import DurationService, { BasicDurations } from "app/services/DurationService";

export const buildCampaignsExportParams = (
    params: Pick<DisplayAdvertiserPublisherParams, "country" | "duration">,
    selectedDomain: string,
    search?: string,
    sort?: { asc: boolean; sort: string },
) => {
    const { from, to, isWindow } = DurationService.getDurationData(params.duration ?? "").forAPI;

    return {
        country: params.country,
        domain: selectedDomain,
        from,
        to,
        includeTerms: search,
        isWindow,
        ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
        ...sort,
    };
};
